import { Layout } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Header, Sidebar } from '../../../components';
import { pageTitles } from '../../../constants/pageTitles';
import { StyledContent } from './style';

const AdminLayout: FC = ({ children }) => {
  const location = useLocation();
  const [pageTitle, setPageTitle] = useState('');

  useEffect(() => {
    const { pathname } = location;
    const basePath = `/${pathname.replace(/^\/([^/]*).*$/, '$1')}`;
    const currentPage = pageTitles.filter(
      pageTitle => pageTitle.basePath === basePath,
    );
    const { title } = currentPage[0] || '';

    setPageTitle(title);

    return () => {
      setPageTitle('');
    };
  }, [location]);

  return (
    <Layout>
      <Sidebar width={208} />

      <Layout style={{ marginLeft: '208px' }}>
        <Header pageTitle={pageTitle} />

        <StyledContent>{children}</StyledContent>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
